import React from 'react';
import PropTypes from 'prop-types';

import { ButtonsCollection, ModalWindow, FormsCollection } from '../../../../ui-kit';
import SprintForm from './sprintForm';
import './style.sass';

const ModalView = ({
  isOpen,
  isPending,
  onCloseModal,
  handleChange,
  handleBlur,
  handleSubmit,
  values,
  errors,
  getValidFinishDate,
  onChangeStartDate,
  title,
  titleAction,
}) => (
  <ModalWindow
    isOpen={isOpen}
    onClose={onCloseModal}
    modalName="pinMessage"
    title={title}
    className="new-sprint__modal"
  >
    <FormsCollection.FormWrapper
      handleSubmit={handleSubmit}
    >
      <SprintForm
        handleChange={handleChange}
        handleBlur={handleBlur}
        values={values}
        errors={errors}
        getValidFinishDate={getValidFinishDate}
        onChangeStartDate={onChangeStartDate}
      />
      <div className="button-group">
        <ButtonsCollection.ButtonBrill
          pending={isPending}
          className="button--md new-sprint__button-save button-brill--fill"
          type="submit"
        >
          {titleAction}
        </ButtonsCollection.ButtonBrill>
      </div>
    </FormsCollection.FormWrapper>
  </ModalWindow>
);

ModalView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  getValidFinishDate: PropTypes.func.isRequired,
  onChangeStartDate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  titleAction: PropTypes.string.isRequired,
};


export default ModalView;
